import React, {useEffect, useState} from 'react';
import {Button, Card, Container, Modal, ModalBody, ModalHeader, Spinner} from 'reactstrap';
import {doc, getDoc, updateDoc} from 'firebase/firestore';
import {getDb} from 'util/Constants';
import DataTable from 'react-data-table-component'
import AptitudeModal from './AptitudeModal';
import Swal from "sweetalert2";

export default function AptitudeGames() {
    const [aptitude, setAptitude] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [load, setLoad] = useState(true)
    const [btnLoad, setBtnLoad] = useState(false)

    const column = [
        // {
        //     name: 'Evaluation',
        //     minWidth: '15%',
        //     selector: row => row.evaluation,
        // },
        {
            name: 'No of Questions',
            selector: row => row.nbrOfQues,
        },
        {
            name: 'Tab Name',
            selector: row => row.tabName,
        },
        {
            name: 'Name',
            selector: row => row.name,
            minWidth: '15%'
        },
        {
            name: 'Logo',
            center: true,
            selector: (row) => <img src={row.image} width="50" alt="Logo" />
        },
        {
            name: 'Level Objective',
            minWidth: '20%',
            wrap: true,
            center: true,
            selector: row => row.goalText,
            cell: row => {
                return (
                    <div className="small">
                        {row.goalText}
                    </div>
                )
            }
        },
        {
            name: "Passing Score",
            selector: row => row.passingScore,

        },
        {

            name: "Time",
            selector: row => row.time,


        },
        {

            name: '',
            // width: '250px',
            selector: row => null,
            cell: row => (
                <div className="d-flex justify-content-end w-100 px-2">
                    <Button
                        onClick={() => toggleModal(row)}
                        color="default"
                        size="sm"
                    >
                        <i className="fas fa-pen" />
                    </Button>

                    <Button
                        onClick={() => deleteData(row)}
                        disabled={btnLoad === row.tabName}
                        color="danger"
                        size="sm"
                    >{btnLoad === row.tabName ?
                        <Spinner
                            className="mx-2"
                            color={'white'}
                            size={'sm'}
                        >
                            Loading...
                        </Spinner> : <i className="fas fa-trash" />}
                    </Button>
                </div>
            )
        }

    ];

    const deleteData = async (item) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "This action will permanently delete the Mini game!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
            // reverseButtons: true,
        });

        // If user cancels, stop the deletion process
        if (!result.isConfirmed) return;
        setBtnLoad(item.tabName)
        const aptitudeGames = aptitude.filter((e) => e.tabName !== item.tabName)
        const metaGamesRef = doc(getDb(), "Metadata_Games", "aptitude");
        await updateDoc(metaGamesRef, {
            data: aptitudeGames
        });
        setAptitude(aptitudeGames)
        setBtnLoad(false)
    }

    const toggleModal = (item) => {
        if (item?.hasOwnProperty("name")) {
            console.log("1");
            setSelectedItem(item);
        }
        else {
            console.log("2");
            setSelectedItem({})
        }
        setModalOpen((prev) => !prev);
    };

    useEffect(() => {
        const fetchData = async () => {
            const docRef = doc(getDb(), 'Metadata_Games', 'aptitude');
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                const data = docSnap.data().data;
                setAptitude(data)
                console.log(data);
                setLoad(false)
            } else {
                setLoad(false)

                console.log('No such document!');
            }
        }
        fetchData();
    }, []);

    return (
        <>
            {/* <div className="header pb-8 pt-5 pt-md-8" /> */}
            <Container  fluid>
                <div className='d-flex justify-content-end'>
                    <Button
                        onClick={toggleModal}
                        color="default"
                    >
                        Add
                    </Button>
                </div>
                <Card>
                    <DataTable
                        columns={column}
                        data={aptitude}
                        progressPending={load}
                        pagination={true}

                    />
                </Card>
            </Container>
            <Modal isOpen={modalOpen} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>{selectedItem?.hasOwnProperty('name') ? 'Update' : 'Add'} Aptitude</ModalHeader>
                <ModalBody>
                    <AptitudeModal isOpen={modalOpen} toggle={toggleModal} item={selectedItem} aptitude={aptitude} setAptitude={setAptitude} />
                </ModalBody>
            </Modal>
        </>
    )
}
